export function notificationDestination(message, account) {
    const data = message?.data || message || {};
    const kind = String(message?.notifType || data.type || '');
    if (kind === 'schedule_reminder' || kind.startsWith('motivation_') || kind === 'schedule_pre_lock_warning') {
        return account?.role === 'manager' || (account?.permissions || []).includes('schedule.edit') ? '/manager/assign' : '/my-schedule';
    }
    const permissions = account?.permissions || [];
    const allowed = tag => permissions.includes(tag) || account?.is_superuser === true;
    if (kind.startsWith('fine') || kind === 'deduction') {
        if (account?.role === 'workstation') return '/workstation/fines';
        return allowed('finance.fines.view') ? '/manager/fines' : '/my-fines';
    }
    if (kind.startsWith('reward') || kind === 'daily_reward') return allowed('finance.rewards.view') ? '/manager/rewards' : '/my-salary';
    if (['fill_request_approved', 'fill_request_rejected', 'change_request_review', 'schedule_changed', 'morning_reminder', 'assignment', 'day_confirmed'].includes(kind) || kind.startsWith('assignment_reminder')) return '/my-schedule';
    if (kind.startsWith('substitution_')) {
        return allowed('schedule.substitutions.review') ? '/manager/substitutions' : '/my-schedule';
    }
    let raw = message?.url || data.url || '/';
    if (typeof raw !== 'string') return '/';
    try {
        const target = new URL(raw, window.location.origin);
        if (target.origin !== window.location.origin) return '/';
        raw = target.pathname + target.search + target.hash;
    } catch { return '/'; }
    if (raw.split(/[?#]/)[0] === '/gcoin/notifications' && ['photographer', 'admin', 'admin_photographer'].includes(account?.role)) return '/gcoin/profile/me';
    // These personal routes also accept manager/custom-role accounts.
    if (raw.startsWith('/manager') && account?.role !== 'manager' && !allowed('events.view') && !permissions.some(p => p.startsWith('schedule.') || p.startsWith('finance.'))) return '/';
    return raw;
}
